import * as React from 'react';
import { IconProps } from '../types';

const IcPercent = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M20.046 4.455c.439.439.439 1.151 0 1.59l-13.5 13.5a1.125 1.125 0 1 1-1.591-1.59l13.5-13.5c.439-.44 1.151-.44 1.59 0ZM7.625 5.625a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-3.75 1.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM17.375 15.375a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-3.75 1.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcPercent;
